import React, { useEffect, useState } from 'react';
import StepLogin from './steps/stepLogin';
import LeftChevron from '../../assets/images/left-chevron.svg';
import { Image, ProgressBar } from '../../components/componentIndex';
import LogoIcon from '../../assets/images/logo/Logo.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthenticationContext } from '../../services/slices/AuthenticationSlicer';
import PersonalInformationService from '../../services/API/personalInformationService';
import { toast } from "react-toastify";
import { useCallback } from "react";

const steps = [0, 1, 2, 3, 4, 5, 6];
// const steps = [0, 1, 2, 3, 4, 5, 6];

const Login = () => {
  const { state: data } = useAuthenticationContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState(0);
  const [personalInfo, setPersonalInfo] = useState({});
  const [formValues, setFormValues] = useState({
    userId: '',
    countryCodes: '+1',
    mobileNumber: '',
    otp: '',
    email: '',
    firstName: '',
    lastName: '',
    profile: '',
    sex: '',
    day: null,
    month: null,
    year: 1990,
    session: '',
    magicToken:''
  });
  useEffect(() => {
     
    if (data && data?.userData && window.location.pathname.includes('login')) {
      navigate('/landing'); // Redirect to the landing page
    }
  })
  useEffect(() => {
    if (data && data?.result) {
      getPersonalInfo(); // This will only be called once on component mount
    }
  }, []);


  const handleSetFormValue = (personalInfo) => {
    const phoneNumber = personalInfo?.phoneNumber?.slice(-10);
    const countryCode = personalInfo?.phoneNumber?.slice(0, 3);
    const dobList = personalInfo?.dateOfBirth?.split('/');
    setFormValues({
      userId: personalInfo.fkUserId,
      countryCodes: countryCode,
      mobileNumber: phoneNumber,
      email: personalInfo.emailAddress,
      firstName: personalInfo.firstName,
      lastName: personalInfo.lastName,
      profile: personalInfo.profileSignedUrl,
      sex: personalInfo.fkGenderId === 1 ? 'Male' : personalInfo.fkGenderId === 2 ? 'Female' : null,
      day: dobList?.length > 0 ? dobList[0] : 1,
      month: dobList?.length > 0 ? dobList[1] : 1,
      year: dobList?.length > 0 ? dobList[2] : 1990,
      session: ''
    });
  };

  useEffect(() => {
    let currentStep;
    if (personalInfo && personalInfo.fkUserId) {
      handleSetFormValue(personalInfo);
      if (!formValues?.email && !formValues?.firstName && !formValues?.lastName && !formValues?.sex) {
        checkCurrentStep(currentStep);
      } else {
        if (!formValues.email || formValues.email === '') {
          setStepAndRedirect(2);
        } else if (!formValues.firstName || formValues.firstName === '') {
          setStepAndRedirect(3);
        } else if (!formValues.profile || formValues.profile === '') {
          setStepAndRedirect(4);
        } else if (!formValues.sex) {
          setStepAndRedirect(5);
        } else if (!formValues.day || formValues.day === '') {
          setStepAndRedirect(6);
        }
      }
    } else {
      checkCurrentStep(currentStep);
    }
  }, [personalInfo.fkUserId]);

  // Check Current Step
  const checkCurrentStep = () => {
    let currentStep = parseInt(searchParams.get('step')); // Get the 'step' parameter
    if (isNaN(currentStep)) {
      currentStep = 0;
    }
    setCurrentStep(currentStep);
    navigateToStep(currentStep);
  };
  
  // const checkCurrentStep = (currentStep) => {
  //   currentStep = parseInt(window?.location?.search?.slice(1));
  //   if (isNaN(currentStep)) {
  //     currentStep = 0;
  //   }
  //   setCurrentStep(currentStep);
  //   navigateToStep(currentStep);
  // };

  // const setStepAndRedirect = (step) => {
  //   setCurrentStep(step);
  //   navigate(`/personalDetails?${step}`);
  // }

  // const handleNext = (step) => {
  //   if (step) {
  //     if (step <= steps.length) {
  //       setCurrentStep(step);
  //       if (step >= 3) {
  //         navigate(`/personalDetails?${step}`);
  //       } else {
  //         navigate(`/login?${step}`);
  //       }
  //     }
  //   } else {
  //     if (currentStep < steps.length - 1) {
  //       setCurrentStep(currentStep + 1);
  //       if (step >= 2) {
  //         navigate(`/personalDetails?${currentStep}`);
  //       } else {
  //         navigate(`/login?${currentStep}`);
  //       }
  //     }
  //   }
  // };

  // const handlePrev = (step) => {
  //   let currentStep = parseInt(window?.location?.search?.slice(1) - 1);
  //   if (currentStep > 0) {
  //     setCurrentStep(currentStep);
  //     if (currentStep >= 2) {
  //       navigate(`/personalDetails?${currentStep}`);
  //     } else {
  //       navigate(`/login?${currentStep}`);
  //     }
  //   }
  // };

  // Helper function to navigate to the right URL based on step
  const navigateToStep = (step) => {
    let queryPeremsData = searchParams.get('callback') ? `step=${step}&callback=${searchParams.get('callback')}` : `step=${step}`
    if (step >= 2) {
      navigate(`/personalDetails?${queryPeremsData}`);
    } else {
      navigate(`/login?${queryPeremsData}`);
    }
  };

  // Function to handle step and redirection
  const setStepAndRedirect = (step) => {
    setCurrentStep(step);  // Set current step
    navigateToStep(step);   // Navigate based on step
  };

  // Handle "Next" button click
  const handleNext = (step) => {
    const findStep = step ? step : currentStep + 1;
    if (findStep < steps.length) {
      setStepAndRedirect(findStep);
    }
  };

  // Handle "Previous" button click
  const handlePrev = () => {
    const findStep = parseInt(searchParams.get('step'));
    let currentStep = findStep - 1;
    if (currentStep > 1) {
      setStepAndRedirect(currentStep);
    }
  };

  const handleLandingPage = () => {
    navigate('/landing');
  };

  const getPersonalInfo = useCallback(async () => {
    try {
      const accessToken = data?.userData?.result?.token
      const response = await PersonalInformationService.getPersonalInformation(accessToken);
      if (response?.statusCode === 200) {
        setPersonalInfo(response.result);
      }
      return response;
    } catch (error) {
      console.error("Login failed: ", error);
    }
  }, []);

  const getFilteredSteps = (currentStep) => {
    if (currentStep <= 1) {
      return [0, 1]; // Show only two progress steps for steps 0 and 1
    }
    return [0, 1, 2, 3, 4, 5, 6]; // Show steps 2, 3, 4, and 5 for currentStep > 1
  };

  return (
    <div>
      {currentStep === 0 && (
        <div className='login-header-logo' onClick={handleLandingPage}>
          <Image imgUrl={LogoIcon} altText={'logo'} className={'logo'} />
        </div>
      )}

      <div className="stepper">
        <div className='d-flex align-items-center progress-bar-margin'>
          {currentStep > 0 && (
            <>
              {currentStep > 2 && (
                <div onClick={handlePrev} className='px-3 cursor-pointer'>
                  <img src={LeftChevron} alt="Left Chevron" />
                </div>
              )}
              <ProgressBar currentStep={currentStep}  steps={getFilteredSteps(currentStep)} />
            </>
          )}
        </div>

        <div className="steps">
          {steps.map((step, index) => (
            <>
              {index === currentStep && (
                <div key={index}>
                  <StepLogin step={step} handleNext={handleNext} formValues={formValues} setFormValues={setFormValues}  />
                </div>
              )}
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Login;